module.exports = __webpack_public_path__ + "static/media/ice-Bucket.3efa42d4.svg";